import React from 'react';
import { Field } from 'redux-form';
import { M } from '@dashboard-experience/mastodon';
import PropTypes from 'prop-types';
import { TextInput } from '../fields/mastodon';
import * as V from '../../lib/validations';
import { getFieldKey } from '../../utils';
import { bestAvailableDisplayText } from './helpers';

function getValidations(field) {
  const vals = [V.required];
  const { validations } = field;

  if (validations) {
    validations.forEach(validation => {
      vals.push(V[validation]);
    });
  }
  return vals.filter(Boolean);
}

function MatrixTextFieldContainer({ field }) {
  if (!field) return null;

  const fieldKey = getFieldKey(field);

  return (
    <M.Container>
      <M.Grid className='cp-form-group'>
        <M.Container.Row>
          <M.Container.Col className='form-group-col' sm={4} md={4} lg={8}>
            <Field
              className='matrix-label-style'
              type='text'
              testId={fieldKey}
              name={fieldKey}
              component={TextInput}
              context={fieldKey}
              validate={getValidations(field)}
              placeholder={bestAvailableDisplayText(field, 'placeholder')}
              helperText={
                field.displayCommentInCandidatePortal && field.comment
              }
              labelControl={bestAvailableDisplayText(field, 'displayTitle')}
            />
          </M.Container.Col>
        </M.Container.Row>
      </M.Grid>
    </M.Container>
  );
}

MatrixTextFieldContainer.propTypes = {
  field: PropTypes.object,
};

MatrixTextFieldContainer.defaultProps = {
  field: null,
};

export default MatrixTextFieldContainer;
